import {contactActions, openwebActions} from '../actionTypes';
import {
  _updateRecord,
  _removeRecord,
  _createStore,
  _addRecords,
  _clone,
  _get,
  _filterDataToMap,
} from '../utils';
import lodash from 'lodash';
import createLogger from '../../utils/createLogger';
const DEBUG = true;
const debug = createLogger(DEBUG, `owpReducer.js`);

const initialState = {
  owpJobs: _createStore(),
};

export default (state = initialState, action) => {

  let owpJobs = _clone(state.owpJobs);
  let id;

  switch (action.type) {

    case openwebActions.GET_OPENWEB_JOBS_SUCCESS:
      if (action.data) {
        debug.enter(`jobs/GET_OPENWEB_JOBS_PAGE_SUCCESS`);
        debug.log(`  OWP Jobs:`, owpJobs);
        owpJobs = _createStore();
        owpJobs = _addRecords(action.data, owpJobs);
        debug.log(`  new postings:`, owpJobs);
      } break;

    case openwebActions.FLUSH_OPENWEB_JOBS_CACHE:
      owpJobs = _createStore(); break;

    case openwebActions.GET_OPENWEB_JOB_SUCCESS:
      debug.enter('jobs/GET_OPENWEB_JOB_SUCCESS');
      if (action.data) {
        debug.log('OWP job:', action.data);
        id = action.data._id;
        switch (action.data.openweb) {
          case `promoted`:
            if (owpJobs.records[id])
              _removeRecord(id, owpJobs);
            break;

          case `closed`:
            if (owpJobs.records[id])
              _removeRecord(id, owpJobs);
            break;

          case `not published`:
            if (owpJobs.records[id])
              _removeRecord(id, owpJobs);
            break;

          default:
            debug.enter(`owp/GET_JOB_DETAILS`);
            debug.log(`  job:`, action.data);
            _updateRecord(action.data, owpJobs);
            break;
        }
      } break;

    case openwebActions.PUT_OPENWEB_CLEAR_SUCCESS:
      debug.enter('jobs/PUT_OPENWEB_CLEAR_SUCCESS');
      if (action.data) {
        debug.log(action.data);
        owpJobs = _createStore();
        owpJobs = _addRecords(action.data, owpJobs);
        debug.log('new postings: ', owpJobs);
        break;
      } break;

    case openwebActions.PUT_OPENWEB_JOB_SUCCESS:
      if (action.data) {
        id = action.data._id;
        switch (action.data.openweb) {
          case `promoted`:
            if (owpJobs.records[id])
              _removeRecord(id, owpJobs);
            break;

          case `closed`:
            if (owpJobs.records[id])
              _removeRecord(id, owpJobs);
            break;

          case `not published`:
            if (owpJobs.records[id]) {
              _removeRecord(id, owpJobs);
            }
            break;

          default:
            _updateRecord(action.data, owpJobs);
            break;
        }
      }
      return {...state, owpJobs};

    case openwebActions.PUT_OPENWEB_PROMOTE_SUCCESS:
      if (action.data) {
        id = action.data._id;
        if (owpJobs.records[id]) {
          _removeRecord(id, owpJobs)
        }
      }
      break;

    case contactActions.PUT_CONTACTS_SUCCESS:
      // get the company id, and see if we have that company in our state.owpJobs -- if so, fix owpJobs.contacts ]\
      if(action.data && lodash.isArray(action.data) && action.data.length > 0) {
        let companyId = action.data[0].companyid;
        debug.log('company_id from response: ' + companyId);
        for (let job_id in owpJobs.records) {
          if (owpJobs.records.hasOwnProperty(job_id)) {
            if (owpJobs.records[job_id].company_id === companyId) {
              debug.log('found job with company id');
              owpJobs.records[job_id].contacts = [...action.data];
              return { ...state, owpJobs };
            }
          }
        }
      }
      return state;


    default:
      return state;
  }

  return {
    ...state,
    owpJobs,
  }

};



// WEBPACK FOOTER //
// ./src/data/owp/owpReducer.js